<template>
	<div class="row-offcanvas row-offcanvas-left" ref="sidebar">
		<div class="sidebar-offcanvas" id="sidebar" role="navigation">
			<b-nav v-if="isEmployee">
				<b-nav-item :class="content == 'DashboardContent' ? 'active': ''" @click="showPage('DashboardContent')"><i class="mh-icon-dashboard"></i> Dashboard</b-nav-item>
				<b-nav-item :class="content == 'AvailableShiftsContent' ? 'active': ''" @click="showPage('AvailableShiftsContent')"><span class="icon-container"><icon name="regular/calendar-plus" scale="2"></icon></span> Available Shifts <b-badge variant="danger" pill>{{availableShifts.length}}</b-badge></b-nav-item>
				<b-nav-item :class="content == 'TimeClockContent' ? 'active': ''" @click="showPage('TimeClockContent')"><i class="mh-icon-watch"></i> Time Clock</b-nav-item>
				<b-nav-item :class="content == 'ScheduleContent' ? 'active': ''" @click="showPage('ScheduleContent')"><i class="mh-icon-calendar"></i> Schedule</b-nav-item>
				<b-nav-item :class="content == 'TimeEntriesContent' ? 'active': ''" @click="showPage('TimeEntriesContent')"><i class="mh-icon-entry"></i> Time Entries</b-nav-item>
				<b-nav-item :class="content == 'PlansContent' ? 'active': ''" @click="showPage('PlansContent')"><span class="icon-container"><icon name="regular/file" scale="2"></icon></span> Plans</b-nav-item>
				<b-nav-item :class="content == 'TimeOffContent' ? 'active': ''" @click="showPage('TimeOffContent')"><i class="mh-icon-plane"></i> Time Off</b-nav-item>
				<b-nav-item :class="content == 'AccidentsIncidentsContent' ? 'active': ''" @click="showPage('AccidentsIncidentsContent')"><i class="mh-icon-ticks"></i> Accidents / Incidents</b-nav-item>
				<b-nav-item :class="content == 'CustomersContent' ? 'active': ''" @click="showPage('CustomersContent')"><i class="mh-icon-users"></i> Participants / Customers <b-badge pill variant="danger">{{customers.length}}</b-badge></b-nav-item>
				<b-nav-item :class="content == 'DocumentsContent' ? 'active': ''" @click="showPage('DocumentsContent')"><span class="icon-container"><icon name="regular/file-alt" scale="2"></icon></span> Documents</b-nav-item>
			</b-nav>
			<b-nav v-if="isClient">
				<b-nav-item :class="content == 'DashboardClientContent' ? 'active': ''" @click="showPage('DashboardClientContent')"><i class="mh-icon-dashboard"></i> Dashboard</b-nav-item>
				<b-nav-item :class="content == 'InvoicesClientContent' ? 'active': ''" @click="showPage('InvoicesClientContent')"><span class="icon-container"><icon name="file-invoice" scale="2"></icon></span> Invoices</b-nav-item>
				<b-nav-item v-if="pmFundingBalances.length > 0" :class="content == 'TimeEntriesContent' ? 'active': ''" @click="showPage('TimeEntriesContent')"><i class="mh-icon-entry"></i> Time Entries</b-nav-item>
				<b-nav-item :class="content == 'AccidentsIncidentsContent' ? 'active': ''" @click="showPage('AccidentsIncidentsContent')"><i class="mh-icon-ticks"></i> Incidents / Complaints</b-nav-item>
				<b-nav-item :class="content == 'DocumentsContent' ? 'active': ''" @click="showPage('DocumentsContent')"><span class="icon-container"><icon name="regular/file-alt" scale="2"></icon></span> Documents</b-nav-item>
			</b-nav>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Dashboard',
		mounted: function () {
			if (this.contentExists()) {
				this.$store.dispatch("Content/show", localStorage.content)
			}
			else {
				if (this.isEmployee)
					this.$store.dispatch("Content/show", "DashboardContent")

				if (this.isClient)
					this.$store.dispatch("Content/show", "DashboardClientContent")
			}
			
			this.$root.$off('toggle-menu')
			this.$root.$on('toggle-menu', this.toggleMenu)
		},
		computed: {
			profile: function () {
				return this.$store.state.Profile.profile
			},
			customers: function () {
				return this.$store.state.Customers.customers
			},
			availableShifts: function () {
				return this.$store.state.Shifts.availableShifts
			},
			pmFundingBalances: function () {
				return this.$store.state.Funding.pmFundingBalances
			},
			isEmployee: function () {
				return this.profile.accounttype == 2
			},
			isClient: function () {
				return this.profile.accounttype == 3
			},
			content: function () {
				return this.$store.state.Content.content
			}
		},
		methods: {
			contentExists: function () {
				return localStorage.content != null && localStorage.content != ""
			},
			showPage: function (content) {
				this.$store.dispatch("Content/show", content)

				localStorage.content = content

				this.toggleMenu()
			},
			toggleMenu: function () {
				var classes = this.$refs.sidebar.classList

				if (classes.contains("active")) {
					classes = classes.remove("active")
				}
				else {
					classes.add("active")
				}
			}
		}
	};
</script>

<style scoped>
</style>